import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import React from "react";
import { ReactComponent as SalesOverviewIcon } from "../../Icons/SalesOverview.svg";
import { ReactComponent as CompanyIcon } from "../../Icons/Company.svg";

function SideBarRouteOptions({ name, icon: Icon, open }) {
  return (
    <div
      style={{
        color: "#6C737F",
        textDecoration: "none",
        display: "block",
        margin: open ? "5px 10px" : 0,
        width: "auto",
        borderRadius: "10px",
      }}
    >
      <ListItemButton
        sx={{
          padding: open ? `0px 0px 0px 10px` : "0px 19px 0px 19px",
          minHeight: 48,
          display: "flex",
          width: "100%",
          justifyContent: open ? "initial" : "center",
          "&:hover": { margin: "auto", background: open ? "" : "none" },
        }}
      >
        <Tooltip title={open ? "" : name} placement="right-start">
          <ListItemIcon
            sx={{
              "& svg path": { stroke: "#6C737F" },
              minWidth: 0,
              marginRight: open ? 0 : "auto",
              justifyContent: "center",
              height: "35px",
              width: "35px",
              display: "flex",
              alignItems: "center",
              borderRadius: "4px",
            }}
          >
            <Icon />
          </ListItemIcon>
        </Tooltip>
        <ListItemText
          primary={name}
          sx={{
            ".MuiTypography-root": {
              fontSize: "14px",
              fontWeight: 500,
              letterSpacing: "-0.25px",
            },
            color: "#6C737F",
            opacity: open ? 1 : 0,
            marginLeft: "10px",
            textTransform: "capitalize",
          }}
        />
      </ListItemButton>
    </div>
  );
}

export default function SideBar() {
  const open = true;
  return (
    <List>
      <SideBarRouteOptions
        name="Sales Overview"
        icon={SalesOverviewIcon}
        open={open}
      />
      <SideBarRouteOptions name="Company" icon={CompanyIcon} open={open} />
    </List>
  );
}
